@if (selectedDataClass) {
<div class="document-workspace">
  <!-- =========================================================
    DOCUMENT HEADER
    ========================================================== -->
  <header class="document-header" [hidden]="activeFileUploadHeader">
    <!-- Left -->
    <div class="document-header__left">
      <!-- Sidebar toggle -->
      <button
        type="button"
        class="icon-btn sidebar-toggle"
        (click)="hideElibaryClass()"
      >
        <i
          class="pi"
          [ngClass]="{
            'pi-angle-double-left': !elibraryComponent.viewLibraryList,
            'pi-angle-double-right': elibraryComponent.viewLibraryList
          }"
        ></i>
      </button>
      <!-- Class information -->
      <div class="document-info">
        <div class="document-title-row">
          <h3
            class="document-title"
            [title]="selectedDataClass.chat_group_name"
          >
            {{
              selectedDataClass.chat_group_name.length > 20
                ? (selectedDataClass.chat_group_name | slice : 0 : 20) + "..."
                : selectedDataClass.chat_group_name
            }}
          </h3>
          <span class="document-status">
            <span class="status-dot"></span>
            Active
          </span>
        </div>
        <span class="document-updated">
          <i class="pi pi-clock"></i>
          {{ selectedDataClass.updatedAt | date : "MMM d, y h:mm a" }}
        </span>
      </div>
      <!-- Edit -->
      @if ( (isUserRole === 1 || isUserRole === 2) &&
      selectedDataClass.chat_group_name ) {
      <button
        type="button"
        class="workspace-action icon-only"
        (click)="editClassesLesson()"
      >
        <i class="pi pi-pen-to-square"></i>
      </button>
      }
    </div>
    <!-- AI Actions -->
    <div class="document-ai-actions">
      <!-- AI Question Answer -->
      @if ( selectedDataClass.model_type === 1 || selectedDataClass.model_type
      === 2 || selectedDataClass.model_type === 3 ) {
      <button
        type="button"
        class="workspace-action ai-action"
        (click)="navigate('answer')"
      >
        <img src="assets/images/ai_question.png" alt="" />
        <span class="ai-label-desktop">AI Question Answers</span>
        <!-- <span class="ai-label-mobile">Ask AI</span> -->
      </button>
      }
      <!-- AI Search -->
      @if ( selectedDataClass.model_type === 1 || selectedDataClass.model_type
      === 3 ) {
      <button
        type="button"
        class="workspace-action ai-action"
        (click)="navigate('search')"
      >
        <img src="assets/images/ai-search.png" alt="" />
        <span>AI Search</span>
      </button>
      }
    </div>
    <!-- Right -->
    @if (!activeDashboard) {
    <div class="document-header__right">
      <!-- Search -->
      <div class="document-search">
        <i class="pi pi-search search-icon"></i>
        <input
          type="text"
          placeholder="Search documents..."
          [(ngModel)]="search"
          (keyup)="searchSubject.next($event)"
        />
        @if (search) {
        <button
          type="button"
          class="search-clear"
          (click)="clearSearchFileList()"
          aria-label="Clear search"
        >
          <i class="pi pi-times"></i>
        </button>
        }
      </div>
      <!-- View switcher -->
      <!-- <div class="view-switcher">
            <button type="button" [class.active]="activeTileView" (click)="showHideModal('tile')" title="Tile View">
              <i class="pi pi-th-large"></i>
              <span>Grid</span>
            </button>
            <button type="button" [class.active]="activeListView" (click)="showHideModal('list')" title="List View">
              <i class="pi pi-list"></i>
              <span>List</span>
            </button>
          </div> -->
      <!-- Actions -->
      <div class="header-actions">
        @if (isUserRole === 1 || isUserRole === 2) {
        <button
          type="button"
          class="upload-button"
          (click)="showHideModal('upload')"
        >
          <i class="pi pi-cloud-upload"></i>
          <span>Upload</span>
        </button>
        }
        <!-- <button type="button" class="close-workspace" (click)="closeActiveClass()" aria-label="Close">
            <i class="pi pi-times"></i>
          </button> -->
      </div>
    </div>
    }
  </header>
  <!-- =========================================================
  CONTENT
  ========================================================== -->
  <main class="document-content">
    <div
      class="document-scroll"
      appInfiniteScroll
      (reachedBottom)="onScrollDown()"
      [infiniteScrollDistance]="modalScrollDistance"
      [infiniteScrollThrottle]="modalScrollThrottle"
      [scrollWindow]="false"
      (scrolled)="onScrollDown()"
    >
      <!-- =====================================================
      TILE VIEW
      ====================================================== -->
      @if ( !activeListView && activeTileView && !activeDashboard &&
      !activeFileUpload ) {
      <section class="document-view document-grid">
        <app-e-library-tile
          [groupName]="selectedDataClass.chat_group_name"
          [classFileList]="getElibraryFileList"
          [totalUserCount]="getUserCount"
          [totalDocumentCount]="getLessonCount"
          [userReadCount]="getReadUserCount"
          [selectedClassList]="groupUserList"
          [getSearchLessonList]="getSearchItem"
          [modelType]="selectedDataClass.model_type"
        ></app-e-library-tile>
      </section>
      }
      <!-- =======================================================
      LIST VIEW
      ============================================================-->
      @if (activeListView && !activeTileView && !activeDashboard &&
      !activeFileUpload) {
      <section class="document-view document-list">
        <app-e-library-list
          [groupName]="selectedDataClass.chat_group_name"
          [classFileList]="getElibraryFileList"
          [totalUserCount]="getUserCount"
          [totalDocumentCount]="getLessonCount"
          [userReadCount]="getReadUserCount"
          [selectedClassList]="groupUserList"
          [getSearchLessonList]="getSearchItem"
          [modelType]="selectedDataClass.model_type"
        ></app-e-library-list>
      </section>
      }
      <!-- =====================================================
      DASHBOARD VIEW
      ====================================================== -->
      @if ( !activeListView && !activeTileView && activeDashboard &&
      !activeFileUpload ) {
      <section class="document-dashboard">
        <app-e-library-dashboard
          [classFileList]="getElibraryFileList"
          [gridUserCount]="selectedClass"
          [gridCountFileList]="getLessonCount"
        ></app-e-library-dashboard>
      </section>
      }
    </div>
  </main>
</div>
}

<!-- ===========================================================
UPLOAD MODAL
============================================================ -->
@if (activeFileUpload) {
<div
  class="upload-overlay"
  role="dialog"
  aria-modal="true"
  aria-labelledby="uploadTitle"
>
  <div class="upload-dialog">
    <!-- Header -->
    <header class="upload-dialog__header">
      <div class="upload-dialog__identity">
        <div class="upload-dialog__icon">
          <i class="pi pi-folder-open"></i>
        </div>
        <div>
          <!-- <span class="upload-dialog__eyebrow">
            Document Library
          </span> -->
          <h2 id="uploadTitle" class="upload-dialog__title">
            {{ selectedDataClass.chat_group_name }}
          </h2>
          @if (selectedDataClass?.description) {
          <p class="upload-dialog__description">
            {{ selectedDataClass.description }}
          </p>
          }
        </div>
      </div>
      <button
        type="button"
        class="upload-dialog__close"
        (click)="hideFileUploadModal()"
        aria-label="Close dialog"
      >
        <i class="pi pi-times"></i>
      </button>
    </header>
    <!-- Body -->
    <main class="upload-dialog__body">
      <app-e-library-upload
        [selectedClassList]="groupUserList"
        [isSelectedDoc]="selectedDataClass"
      ></app-e-library-upload>
    </main>
  </div>
</div>
}

<!--edit document name-->
@if (viewControl.editClassesDetails) {
<div class="edit-document-overlay">
  <div class="edit-document-modal">
    <!-- Header -->
    <div class="edit-modal-header">
      <div class="header-content">
        <div class="header-icon">
          <i class="pi pi-file-edit"></i>
        </div>
        <div>
          <h3>Edit Document</h3>
          <p>Update document information and access permissions</p>
        </div>
      </div>
      <button
        type="button"
        class="modal-close-btn"
        aria-label="Close"
        (click)="closeClassesDetails()"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
    <!-- Body -->
    <div class="edit-modal-body">
      <form [formGroup]="newGroupForm" novalidate>
        <!-- Basic Information -->
        <section class="form-section">
          <div class="section-heading">
            <div class="section-icon">
              <i class="pi pi-file"></i>
            </div>
            <div>
              <h4>Document Information</h4>
              <p>Manage the basic details of this document</p>
            </div>
          </div>
          <div class="form-grid">
            <!-- Title -->
            <div class="form-field full-width">
              <label for="documentTitle">
                Document Title
                <span class="required">*</span>
              </label>
              <div class="input-wrapper">
                <i class="pi pi-pencil"></i>
                <input
                  id="documentTitle"
                  type="text"
                  formControlName="chat_group_name"
                  placeholder="Enter document title"
                  autocomplete="off"
                />
              </div>
              <form-validation
                [control]="newGroupForm.controls.chat_group_name"
              >
              </form-validation>
            </div>
            <!-- Description -->
            <div class="form-field full-width">
              <label for="documentDescription">
                Description
                <span class="optional">Optional</span>
              </label>
              <textarea
                id="documentDescription"
                formControlName="chat_description"
                rows="4"
                placeholder="Add a short description about this document"
                (keydown)="keyDownHandler($event)"
              >
              </textarea>
            </div>
            <!-- Model -->
            <div class="form-field">
              <label for="modelType">
                Model Type
                <span class="required">*</span>
              </label>
              <div class="select-wrapper">
                <i class="pi pi-sparkles"></i>
                <select id="modelType" formControlName="model_type">
                  <option value="">Select Model Type</option>
                  @for (item of modelTypeList; track item) {
                  <option [value]="item.value">
                    {{ item.label }}
                  </option>
                  }
                </select>
                <i class="pi pi-chevron-down select-arrow"></i>
              </div>
            </div>
          </div>
        </section>
        <!-- Access Users -->
        <section class="form-section users-section">
          <div class="section-heading users-heading">
            <div class="section-heading-left">
              <div class="section-icon">
                <i class="pi pi-users"></i>
              </div>
              <div>
                <h4>Access Users</h4>
                <p>Manage users who can access this document</p>
              </div>
            </div>
            <button
              type="button"
              class="add-user-button"
              [disabled]="!newGroupForm.valid"
              (click)="openAddUserSection()"
            >
              <i class="pi pi-user-plus"></i>
              <span>Add Users</span>
            </button>
          </div>
          <!-- Selected count -->
          @if (selectedIdList.length > 0) {
          <div class="selected-users-info">
            <div class="selected-info-icon">
              <i class="pi pi-check"></i>
            </div>
            <span>
              <strong>{{ selectedIdList.length }}</strong>
              user(s) selected
            </span>
          </div>
          }
          <!-- User list -->
          <div class="users-list">
            @for (user of userList; track user) {
            <div class="user-row">
              <div class="user-profile">
                <div class="user-avatar">
                  <i class="pi pi-user"></i>
                </div>
                <div class="user-details">
                  <span class="user-name">
                    {{ user.full_name }}
                  </span>
                  @if (user.is_group_admin) {
                  <span class="admin-badge">
                    <i class="pi pi-shield"></i>
                    Admin
                  </span>
                  }
                </div>
              </div>
              @if (!user.is_group_admin) {
              <button
                type="button"
                class="remove-user-btn"
                title="Remove user"
                (click)="deleteGroupUser(user.user_id)"
              >
                <i class="pi pi-trash"></i>
              </button>
              }
            </div>
            }
            <!-- Empty state -->
            @if (!userList?.length) {
            <div class="empty-users">
              <div class="empty-icon">
                <i class="pi pi-users"></i>
              </div>
              <h5>No users added</h5>
              <p>Add users to give them access to this document.</p>
            </div>
            }
            <pagination-loader [showFetchLoader]="showPaginateSpinner">
            </pagination-loader>
          </div>
        </section>
      </form>
    </div>
    <!-- Footer -->
    <div class="edit-modal-footer">
      <button
        type="button"
        class="cancel-button"
        (click)="closeClassesDetails()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="update-button"
        [disabled]="
          (newGroupForm.valid && !newGroupForm.dirty) || newGroupForm.invalid
        "
        (click)="updateGroupDetail(newGroupForm.value)"
      >
        <i class="pi pi-check"></i>
        Update Document
      </button>
    </div>
  </div>
</div>
}

<div class="showAssignment">
  <div
    class="modal e-library-modal"
    [ngClass]="{ 'is-active': domElementControl.showCreateElibrary }"
    appInfiniteScroll
    [scrollWindow]="false"
    [infiniteScrollDistance]="modalScrollDistance"
    [infiniteScrollThrottle]="modalScrollThrottle"
  >
    <!-- Backdrop -->
    <div class="modal-background" (click)="hideElibaryModal(upLoadedFileList)">
      >
    </div>

    <!-- Modal -->
    <div class="modal-card upload-modal-card">
      <form [formGroup]="libraryForm" class="upload-form">
        <!-- Header -->
        <header class="upload-modal-header">
          <div class="upload-header-content">
            <div class="upload-header-icon">
              <i class="pi pi-cloud-upload"></i>
            </div>

            <div>
              <h3>Upload File</h3>
              <p>Add a file to your document library</p>
            </div>
          </div>

          <button
            type="button"
            class="upload-close-btn"
            aria-label="Close"
            (click)="hideElibaryModal(upLoadedFileList)"
          >
            <i class="pi pi-times"></i>
          </button>
        </header>

        <!-- Body -->
        <section class="upload-modal-body">
          <!-- File Upload -->
          <div class="upload-field">
            <label class="upload-label">
              Attachment File
              <span class="required">*</span>
            </label>

            <div
              class="modern-upload-box"
              [ngClass]="{
                'has-file': upLoadedFileList.length > 0
              }"
            >
              <!-- Empty -->
              @if (upLoadedFileList.length === 0) {
              <div class="upload-empty" (click)="elibraryFileInput.click()">
                <div class="upload-cloud-icon">
                  <i class="pi pi-cloud-upload"></i>
                </div>
                <div class="upload-main-text">
                  <strong>Choose a file to upload</strong>
                  <span> Click here to browse files from your device </span>
                </div>
                <button
                  type="button"
                  class="browse-file-btn"
                  (click)="$event.stopPropagation(); elibraryFileInput.click()"
                >
                  <i class="pi pi-folder-open"></i>
                  Browse Files
                </button>
                <div class="supported-files">
                  <span>
                    <i class="pi pi-info-circle"></i>
                    Supported formats
                  </span>
                  <small>
                    PDF, DOC, DOCX, XLS, XLSX, MP3, MP4, AVI, WAV, TXT, PNG,
                    JPG, JPEG, PPT, PPTX
                  </small>
                </div>
              </div>
              <input
                type="file"
                hidden
                #elibraryFileInput
                (change)="chooseUploadFile($event)"
                accept=".pdf, .doc, .docx, .xlx, .xlsx, .mp3, .mp4, .avi, .wav, .txt, .png, .jpg, .jpeg, .ppt, .pptx"
              />
              } @else {
              <div class="selected-file-card">
                <div class="selected-file-icon">
                  @for (f of uploadFileIcons; track f) { @if (f.name ===
                  upLoadedFileList[0].mimeType) {
                  <img [src]="f.icons" alt="File type" width="42" height="42" />
                  } }
                </div>
                <div class="selected-file-info">
                  <span class="selected-file-label"> Selected file </span>
                  <strong
                    class="selected-file-name"
                    [title]="upLoadedFileList[0].name"
                  >
                    {{ upLoadedFileList[0].name }}
                  </strong>
                </div>
                <button
                  type="button"
                  class="remove-file-btn"
                  aria-label="Remove file"
                  title="Remove file"
                  (click)="removeUploadFile(upLoadedFileList)"
                >
                  <i class="pi pi-trash"></i>
                </button>
              </div>
              <button
                type="button"
                class="change-file-btn"
                (click)="elibraryFileInput.click()"
              >
                <i class="pi pi-refresh"></i>
                Choose another file
              </button>
              <input
                type="file"
                hidden
                #elibraryFileInput
                (change)="chooseUploadFile($event)"
                accept=".pdf, .doc, .docx, .xlx, .xlsx, .mp3, .mp4, .avi, .wav, .txt, .png, .jpg, .jpeg, .ppt, .pptx"
              />
              }

              <!-- File Preview -->
            </div>
          </div>

          <!-- Title -->
          <div class="form-field">
            <label class="form-label" for="libraryTitle">
              Title
              <span class="required">*</span>
            </label>

            <div class="input-wrapper">
              <i class="pi pi-pencil"></i>

              <input
                id="libraryTitle"
                type="text"
                class="form-input"
                placeholder="Enter a title for your file"
                autocomplete="off"
                formControlName="title"
              />
            </div>

            <form-validation [control]="libraryForm.controls.title">
            </form-validation>
          </div>
        </section>

        <!-- Footer -->
        <footer class="upload-modal-footer">
          <button
            type="button"
            class="cancel-upload-btn"
            (click)="hideElibaryModal(upLoadedFileList)"
          >
            Cancel
          </button>

          @if (!showBtnSpinner) {
          <button
            type="button"
            class="confirm-upload-btn"
            (click)="createLibrary(libraryForm.value)"
            [disabled]="!libraryForm.valid || upLoadedFileList.length === 0"
          >
            <i class="pi pi-cloud-upload"></i>
            <span>Upload File</span>
          </button>
          } @if (showBtnSpinner) {
          <button type="button" class="confirm-upload-btn loading-btn" disabled>
            <i class="pi pi-spin pi-spinner"></i>
            Uploading...
          </button>
          }
        </footer>
      </form>
    </div>
  </div>
</div>

<div
  class="modalMobileView more-user-modal modal"
  [ngClass]="{ 'is-active': toggleModalSection }"
>
  <div class="modal-background" (click)="closeAddUserSection()"></div>

  <div class="modal-card modern-modal">
    <!-- Header -->
    <header class="modal-card-head modern-modal-head">
      <h5 class="modal-title">
        <i [class]="isPublishMode ? 'pi pi-send' : 'pi pi-users'"></i>
        {{ isPublishMode ? "Publish Document" : "Select More Users" }}
      </h5>
      <button
        class="delete"
        aria-label="close"
        (click)="closeAddUserSection()"
      ></button>
    </header>

    <!-- Body -->
    <section class="modal-card-body modern-modal-body">
      <div class="search-container">
        <div class="control has-icons-left has-icons-right">
          <input
            class="input search-input"
            type="text"
            placeholder="Search users..."
            [(ngModel)]="searchUser"
            (keyup)="searchInList.next($event)"
          />
          <span class="icon is-left">
            <i class="pi pi-search"></i>
          </span>
          @if (searchUser) {
          <span
            class="icon is-right clear-icon"
            (click)="showSearchbox('close')"
          >
            <i class="pi pi-times-circle"></i>
          </span>
          }
        </div>
      </div>

      <div class="select-all-container">
        <div
          class="select-all-item"
          [ngClass]="{ active: isAllSelected }"
          (click)="toggleSelectAll()"
        >
          <div class="user-avatar">
            <i class="pi pi-users"></i>
          </div>
          <span class="user-name">Select All</span>
          @if (isAllSelected) {
          <i class="pi pi-check-circle check-icon"></i>
          }
        </div>
      </div>

      <div
        class="user-list scroll-bar"
        infinite-scroll
        [infiniteScrollDistance]="modalScrollDistance"
        [infiniteScrollThrottle]="modalScrollThrottle"
        [scrollWindow]="false"
        (scrolled)="onScrollDown()"
      >
        @for (user of listOfUsers; track user; let ind = $index) { @if
        (!user['is_aleady_selected']) {
        <div
          class="user-item"
          [ngClass]="{ active: user.is_selected && !user.is_group_admin }"
          (click)="selectUserId(ind, user.user_id)"
        >
          <div class="user-avatar">
            <i class="pi pi-user"></i>
          </div>
          <span class="user-name">{{ user.full_name }}</span>
          @if (user.is_selected && !user.is_group_admin) {
          <i class="pi pi-check-circle check-icon"></i>
          }
        </div>
        } }

        <pagination-loader
          [showFetchLoader]="showPaginateSpinner"
        ></pagination-loader>
      </div>
    </section>

    <!-- Footer -->
    <footer class="modal-card-foot modern-modal-foot">
      @if (!isPublishMode) {
      <button
        type="button"
        class="button is-light clear-btn"
        (click)="clearAddUserSection()"
      >
        <i class="pi pi-refresh"></i> Clear
      </button>
      }
      <div class="button-group">
        <button
          type="button"
          class="button cancel-btn"
          (click)="closeAddUserSection()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="button is-link"
          [class.add-btn]="!isPublishMode"
          [class.publish-btn]="isPublishMode"
          [disabled]="isPublishMode && selectedIdList.length === 0"
          (click)="openAddUserSection()"
        >
          <i [class]="isPublishMode ? 'pi pi-send' : ''"></i>
          {{ isPublishMode ? "Publish" : "Add" }}
        </button>
      </div>
    </footer>
  </div>
</div>
